import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { Snapshot } from '../../types/snapshot.types';
import { useAppQuery } from '../use-app-query.hook';
import { useFormat } from '../use-format.hook';

export const useSnapshotByDate = ({
  companyId,
  date,
  capTableMode,
}: {
  capTableMode?: boolean;
  companyId: string;
  date: Date | null | undefined;
}) => {
  const queryClient = useQueryClient();
  const { format } = useFormat();
  const formattedDate = date ? format(date, 'yyyy-MM-dd') : null;

  const { data: snapshot, isLoading } = useAppQuery<Snapshot>({
    queryKey: [
      QueryKey.GET_SNAPSHOT_BY_DATE,
      QueryKey.GET_SNAPSHOT,
      { companyId, formattedDate, capTableMode: Boolean(capTableMode) },
    ],
    queryFn: () =>
      ApiService.get({
        endpoint: BackendRoute.COMPANIES,
        routePath: [
          companyId,
          'snapshots',
          capTableMode ? 'cap-table-custom-date' : 'custom-date',
          date?.toISOString() || '',
        ],
      }),
    enabled: !!companyId && !!formattedDate && !!date,
  });

  const invalidateQuery = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: [QueryKey.GET_SNAPSHOT_BY_DATE] });
  }, [queryClient]);

  return {
    invalidateQuery,
    snapshot,
    isLoading,
  };
};
